import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type {
  PortalContentRow,
  PortalContentWriteInput,
} from "@colab/shared";

// POST /api/admin/portal-content
//
// Pessimistic — content shape varies per key, so the server is the source of
// truth. Invalidates portalContent.adminList + portalContent.publicAll.
export function useCreatePortalContent() {
  const queryClient = useQueryClient();
  return useMutation<
    { id: string; row: PortalContentRow },
    ApiClientError,
    PortalContentWriteInput
  >({
    mutationFn: (input) =>
      apiFetch<{ id: string; row: PortalContentRow }>("/admin/portal-content", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onError: (err) => {
      toast.error(err.message ?? "Failed to create portal content");
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.portalContent.adminList(),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.portalContent.publicAll(),
      });
    },
  });
}
